import { WorkOrderData } from "@/routes/processes/[processId]/htz/work-orders/[workOrderId]/data/_components/work-order-data";
import { useParams } from "react-router";
import { useGetWorkOrder } from "@/routes/processes/[processId]/htz/work-orders/[workOrderId]/_components/use-work-order-offline";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";

export function DataRoute() {
  const { workOrderId } = useParams();
  const { data: workOrder, isLoading, error } = useGetWorkOrder(workOrderId!);

  if (isLoading) {
    return null;
  }

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (!workOrder) {
    return null;
  }

  return <WorkOrderData workOrder={workOrder} />;
}
